import { RateTogether } from 'react-together-ant-design'

export function AntDesignRateTogetherDemo() {
  return (
    <div className='flex-col place-items-center border border-gray-400 p-2 rounded'>
      <RateTogether rtKey='rating-doc-demo' />
    </div>
  )
}
